import styled, { css } from "styled-components";
import { media } from "../../utils/media/mediaQueries";
import { Button, ButtonBase } from "./Button";

const loginButtonGradient = "var(--inzeloop-ds-color-action-ai-gradient)";

export const AuthPageLayout = styled.div`
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
`;

export const AuthLogoPane = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;

  ${media.desktop`
    width: 66.66%;
  `}
`;

export const AuthActionPane = styled.div`
  display: flex;
  position: relative;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  width: 512px;
  min-height: 100vh;
  background: var(--inzeloop-ds-color-background-subtle);

  ${media.desktop`
    width: 33.33%;
    min-width: 512px;
  `}
`;

export const AuthTitle = styled.div`
  position: absolute;
  top: 71px;
  left: 40px;
`;

export const AuthContentPanel = styled.div`
  display: flex;
  width: 402px;
  flex-direction: column;
  align-items: stretch;
  gap: var(--inzeloop-ds-spacing-2xl);
`;

export const AuthSubmitButton = styled(Button).attrs({
  variant: "ai",
  fullWidth: true,
})`
  height: 48px;
  padding: var(--inzeloop-ds-spacing-md) var(--inzeloop-ds-spacing-xl);
  font-size: var(--inzeloop-ds-font-size-14-7px);
  line-height: var(--inzeloop-ds-line-height-xs);

  &&[aria-busy="true"] {
    background: ${loginButtonGradient};
    color: var(--inzeloop-ds-color-text-inverse);
    cursor: wait;
  }
`;

export const AuthNavigation = styled.div`
  display: flex;
  width: 100%;
  padding-top: var(--inzeloop-ds-spacing-lg);
  border-top: 1px solid var(--inzeloop-ds-color-border-medium);
`;

export const authNavigationTextStyles = css`
  margin: 0;
  color: var(--inzeloop-ds-color-action-primary);
  font-family: var(--inzeloop-ds-font-family-sans);
  font-size: var(--inzeloop-ds-font-size-md);
  font-style: normal;
  font-weight: var(--inzeloop-ds-font-weight-regular);
  line-height: var(--inzeloop-ds-line-height-25-5px);
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: auto;
  text-underline-position: from-font;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
`;

export const AuthNavigationButton = styled(ButtonBase).attrs({
  type: "button",
})`
  ${authNavigationTextStyles}
  width: fit-content;
  border: 0;
  background: var(--inzeloop-ds-color-background-transparent);
  padding: 0;
`;

export const PasswordStrengthMeter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--inzeloop-ds-spacing-sm);
  align-self: stretch;
`;

export const PasswordStrengthRow = styled.div`
  display: flex;
  align-items: center;
  gap: var(--inzeloop-ds-spacing-sm);
  width: 100%;
`;
export const PasswordStrengthText = styled.div<{ score: number }>`
  display: flex;
  align-items: center;
  gap: var(--inzeloop-ds-spacing-xs);
  font-family: var(--inzeloop-ds-font-family-sans);
  font-size: var(--inzeloop-ds-font-size-xs);
  font-weight: var(--inzeloop-ds-font-weight-regular);
  line-height: var(--inzeloop-ds-line-height-xs);

  color: ${({ score }) => {
    if (score === 1) return "var(--inzeloop-ds-color-action-danger)";
    if (score === 3) return "var(--inzeloop-ds-color-feedback-warning-text)";
    if (score === 5) return "var(--inzeloop-ds-color-status-positive-text)";
    return "var(--inzeloop-ds-color-text-subtle)";
  }};
`;

export const PasswordStrengthTrack = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--inzeloop-ds-spacing-xs);
  flex: 1 0 0;
`;

export const PasswordStrengthSegment = styled.div<{ $active: boolean }>`
  width: 60px;
  height: 4px;
  background-color: ${({ $active }) =>
    $active
      ? "var(--inzeloop-ds-color-action-primary)"
      : "var(--inzeloop-ds-color-border-muted)"};
`;

export const PasswordRules = styled.div`
  display: flex;
  width: 384px;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--inzeloop-ds-spacing-xs);
`;

export const PasswordRule = styled.div<{
  $valid?: boolean;
  $warning?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: var(--inzeloop-ds-spacing-10px);

  font-size: var(--inzeloop-ds-font-size-xs);
  font-weight: var(--inzeloop-ds-font-weight-regular);
  font-family: var(--inzeloop-ds-font-family-sans);
  line-height: var(--inzeloop-ds-line-height-sm);

  color: ${({ $valid, $warning }) => {
    if ($warning) return "var(--inzeloop-ds-color-action-danger)";
    if ($valid) return "var(--inzeloop-ds-color-status-positive-text)";
    return "var(--inzeloop-ds-color-text-subtle)";
  }};
`;
